// Sentry for the browser bundle — client-side errors land in the SAME
// project/release as the server (brainbox, release brainbox@<version>), so
// "which deploy broke the UI" reads identically to the Elixir side.
//
// Config rides meta tags rendered by the root layout from the server's
// runtime config: no DSN meta (dev without SENTRY_DEV=true) means this is a
// no-op. Release-health sessions are deliberately NOT tracked here — the
// server's request-mode aggregates (Brainbox.SentrySessions) own crash-free
// numbers, and browser page-load sessions would pollute them — so the
// BrowserSession default integration is stripped. Errors only.
import * as Sentry from '@sentry/browser'
import { isBenignLiveViewRejection } from './lib/sentry_filter.mjs'

const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content || ''

const dsn = meta('sentry-dsn')
if (dsn) {
  Sentry.init({
    dsn,
    release: meta('sentry-release') || undefined,
    environment: meta('sentry-environment') || undefined,
    sendClientReports: false,
    integrations: (defaults) => defaults.filter((i) => i.name !== 'BrowserSession'),
    beforeSend: (event) => (isBenignLiveViewRejection(event) ? null : event)
  })
}

// Named re-exports only, deliberately — do NOT add `export default Sentry`
// back. esbuild tree-shakes the `import * as Sentry` above down to the handful
// of entry points actually reached (init and its dependencies), but exporting
// the namespace object and importing it elsewhere forces the whole SDK to be
// retained, since property access on it can't be proven static. Measured on
// this bundle: 2.5mb with the named re-export, 3.4mb with the default.
export { addBreadcrumb, captureException } from '@sentry/browser'
